import React, {useEffect, useRef} from 'react';
import './look-around-floor.scss'
import {inject, observer} from "mobx-react";
import showPrice from "utils/show-price";
import {useHistory} from 'react-router-dom'
import MyRouterUtil from "../../../../../../utils/MyRouterUtil";
import {getGoodsType} from "../../../../../../utils/GoodsTypeUtil";
import GoodsType from "../../../../../../enum/GoodsType";

function LookAroundFloor({paySuccess: store}) {
    const {lookAround} = store;
    const history = useHistory();
    const goodsListContainer = useRef()

    const toGoodsInfo = ({goodsType, id}) => {
        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id})
    }

    const onScroll = e => {
        const rect = goodsListContainer.current.getBoundingClientRect()
        const top = rect.top
        const height = rect.height
        const clientHeight = document.body.clientHeight
        if (clientHeight - top > height && !store.lookAround.loading) {
            store.lookAround.pageSize += store.lookAround.PAGE_SIZE
        }
    }
    useEffect(() => {
        window.addEventListener('touchmove', onScroll)
        return () => {
            window.removeEventListener('touchmove', onScroll)
        }
    }, [])

    function renderGoodsList(goodsList) {

        return goodsList.map(
            (
                {
                    id,
                    mainPic,
                    name,
                    currentPrice,
                    pddShop,
                    isPddShop,
                    isJdShop,
                    isSpecialPrice,
                    isHot
                }
            ) => {

                const goodsType = getGoodsType({isPddShop, isJdShop})

                let tagDom = null;
                if (goodsType !== GoodsType.SELF) {
                    tagDom = (
                        <>
                            {isHot ? <img src={require('./img/hot-tag.png')} alt="" className="tag"/> : ""}
                            {isSpecialPrice ?
                                <img src={require('./img/special-price-tag.png')} alt="" className="tag"/> : ""}
                        </>
                    )
                } else {
                    tagDom = <img src={require('./img/self-tag.png')} alt="" className="tag"/>
                }

                return <div className="goods" key={id} onClick={() => toGoodsInfo({id, goodsType})}>
                    <div className="img-block">
                        <div className="img-wrapper">
                            <img src={mainPic} alt=""/>
                        </div>
                    </div>
                    <div className="info-block">
                        <div className="name">{name}</div>
                        <div className="price-floor">
                            <div className="current-price">{showPrice(currentPrice)}</div>
                            <div className="tag-block">
                                {tagDom}
                            </div>
                        </div>
                    </div>
                </div>
            }
        )
    }

    return <div className="glx-pay-success-look-around-floor">
        <div className="container">
            {/*<div className="title-floor">*/}
            {/*    <div className="div title">随便看看</div>*/}
            {/*</div>*/}
            <div className="goods-list" ref={goodsListContainer}>
                {renderGoodsList(lookAround.list)}
            </div>
        </div>
        <div className="load-more">
            {
                store.lookAround.loading
                    ? <div>加载中...</div>
                    : <div>上拉加载更多</div>
            }
        </div>
    </div>
}

export default inject('paySuccess')(observer((LookAroundFloor)))